/// <reference path="./global.d.ts" />

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './configureStore';
import registerServiceWorker from './registerServiceWorker';
import './configGlobal';
import App from './App';
import * as appUI from './modules/uis/app';
import * as Rollbar from 'rollbar';
import { rollbarAccessToken, reactAppEnvironment } from './appconfig';

const store = configureStore();

export const rollbar = new Rollbar({
  accessToken: rollbarAccessToken,
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: reactAppEnvironment
  }
});

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root') as HTMLElement
);

// Global dirty monitor.
// Needed as DirtyMonitor can only handle React Router routing.
window.addEventListener('beforeunload', function (e: BeforeUnloadEvent) {
  const hasDirty = appUI.selectors.getHasDirtyData(store.getState());
  if (!hasDirty) { return ''; }

  const confirmationMessage = '\o/';
  e.returnValue = confirmationMessage;     // Gecko, Trident, Chrome 34+
  return confirmationMessage;              // Gecko, WebKit, Chrome <34
});

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.tsx